module.exports = __webpack_public_path__ + "img/Tishmanlogo.b54c553e.jpeg";